"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QUESTION_INPUT_TYPES = void 0;
var QUESTION_INPUT_TYPES;
(function (QUESTION_INPUT_TYPES) {
    QUESTION_INPUT_TYPES["TEXT"] = "TEXT";
    QUESTION_INPUT_TYPES["TEXTAREA"] = "TEXTAREA";
    QUESTION_INPUT_TYPES["CHECKBOX"] = "CHECKBOX";
    QUESTION_INPUT_TYPES["SELECT"] = "SELECT";
    QUESTION_INPUT_TYPES["WYSIWYG"] = "WYSIWYG";
    QUESTION_INPUT_TYPES["DATE"] = "DATE";
    QUESTION_INPUT_TYPES["MULTI_CHECKBOX"] = "MULTI_CHECKBOX";
    QUESTION_INPUT_TYPES["NUMBER"] = "NUMBER";
    QUESTION_INPUT_TYPES["EMAIL"] = "EMAIL";
    QUESTION_INPUT_TYPES["MULTI_SELECT"] = "MULTI_SELECT";
    QUESTION_INPUT_TYPES["REPEATER"] = "REPEATER";
    QUESTION_INPUT_TYPES["FAMILY_MEMBERS"] = "FAMILY_MEMBERS";
    QUESTION_INPUT_TYPES["HEADING"] = "HEADING";
    QUESTION_INPUT_TYPES["REPEATER_CHILD_INFO"] = "REPEATER_CHILD_INFO";
    QUESTION_INPUT_TYPES["REPEATER_EMPLOYMENT_INFO"] = "REPEATER_EMPLOYMENT_INFO";
    QUESTION_INPUT_TYPES["REPEATER_PREVIOUS_RESIDENCE"] = "REPEATER_PREVIOUS_RESIDENCE";
    QUESTION_INPUT_TYPES["REPEATER_MILITARY_SERVICE"] = "REPEATER_MILITARY_SERVICE";
    QUESTION_INPUT_TYPES["REPEATER_POLITICAL_GROUP"] = "REPEATER_POLITICAL_GROUP";
    QUESTION_INPUT_TYPES["REPEATER_PRISONER_TREATMENT"] = "REPEATER_PRISONER_TREATMENT";
})(QUESTION_INPUT_TYPES = exports.QUESTION_INPUT_TYPES || (exports.QUESTION_INPUT_TYPES = {}));
